export default __webpack_public_path__ + "static/blog-thumb-3-dc173427f4e560e0e93764c427498c31.webp";